import Konva from 'konva';
import { RoofShape } from "./RoofShape";
import { SC_Input } from "../input/SC_Input";
import * as konva from "../konva/getCanvas";
import { SC_Beam } from "./SC_Beam";
import { DrawScale } from "../draw_scale";
import { Rectangular } from "./Rectangular";
import { Hip } from "./Hip";
import { PartialHip } from "./PartialHip";
import CanvasScroll from "./canvasScrollBars";

export class DrawRoof {

    stage: Konva.Stage;
    layerRoof: Konva.Layer = konva.getCanvasLayer();
    scrollLayers: Konva.Layer = konva.getCanvasLayer();
    layerScale: Konva.Layer = konva.getCanvasLayer();
    layerBeam: Konva.Layer = konva.getCanvasLayer();
    static scaleFactor: number = 0.45;
    static listOfModules: any[] = [];
    static selectedPanels: any[] = [];
    start: any = {
        x: 0,
        y: 0
    }
    end: any = {
        x: 0,
        y: 0
    }
    isMouseDown = false;
    selectedGroup: Konva.Group;

    nRoofRange: number;
    nsDist_value: number = 80;
    nsDist1_value: number = 10;
    nsDist2_value: number = 10;
    nsAmount_value: number;
    rbDist1_selected: boolean;
    rbDist2_selected: boolean;
    rbAmount_selected: boolean;
    nRoofHeight: number;
    nRoofWidth: number;
    nDistMin: number;
    nDistMax: number;
    nDistDefault: number;
    nsAmount_minimum: number;
    nsAmount_maximum: number;
    nsDist_minimum: number;
    nsDist_maximum: number;
    
    static getScaleValue() {
        const position: any = document.getElementById("roof_structure_canvas_container");
        if(position) {
            const scaleX = position.offsetWidth / (RoofShape.getCurrentRoofWidth() + 200);
            const scaleY = position.offsetHeight / (RoofShape.getCurrentRoofHeight() + 200);
            this.scaleFactor = scaleX > scaleY ? scaleY : scaleX;
            return scaleX > scaleY ? scaleY : scaleX;
        }
        return 0.45
    }
    initRoof(roofId: string) {
        DrawRoof.getScaleValue();
        this.nRoofWidth = RoofShape.getCurrentRoofWidth();
        this.nRoofHeight = RoofShape.getCurrentRoofHeight();
        let w: any, h: any, s: any = DrawRoof.scaleFactor;
       
        const container = document.getElementById("roof_structure_canvas_container");
        this.stage = konva.getCanvasStage({
            container: roofId,
            width: container ? container.offsetWidth : window.screen.width,  //w && w > window.screen.width ? w : window.screen.width,
            height: container ? container.offsetHeight : window.screen.height,  // h && h > window.screen.height ? h : window.screen.height,
        });
        // verticalBar(stage: any, scrollLayers: any, layer: any, HEIGHT: any)
        new DrawScale().drawScale(this.stage, this.layerScale);
        this.stage.add(this.layerScale);
        this.stage.add(this.layerRoof);
        this.stage.add(this.layerBeam);
      
        setTimeout(() => {
            this.roofDrawing();
        }, 100);
        this.stage.scaleX(DrawRoof.scaleFactor);
        this.stage.scaleY(DrawRoof.scaleFactor);
        this.stage.draw();

        setTimeout(() => {
            const container = document.getElementById("roof_structure_canvas_container");
            const scrollCanvas = document.getElementById("roofContainer");
            if (container && scrollCanvas) {
                scrollCanvas.style.width = w ? w + 'px' : (RoofShape.getCurrentRoofWidth() * DrawRoof.scaleFactor) + 65 + 'px';
                scrollCanvas.style.height = h ? h + 'px' : (RoofShape.getCurrentRoofHeight() * DrawRoof.scaleFactor) + 65 + 'px';
                if (scrollCanvas.offsetWidth > container.offsetWidth) {
                }
                if (scrollCanvas.offsetHeight > container.offsetHeight) {
                }
            }
            }, 100);
            // }

        }

    // Based upon selected Roof shape calling roof drawing classes like Rectangular, Hip, PartialHip
    roofDrawing() {
            if(SC_Input.iRoofShape == RoofShape.PULT) {
            new Rectangular().drawPult(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.SATTEL) {
            new Rectangular().drawSattel(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.WALM) {
            new Hip().drawHip(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.SCHED) {
            new Rectangular().drawSched(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.KRUEPPELWALM) {
            new PartialHip().drawPartialHip(this.layerRoof);
        } else if (SC_Input.iRoofShape == RoofShape.MANSARD) {
            // Rectangular.drawMansard();
        }
        this.fetchInput();
    }

    // Setting  some default values like beam distance fist and rafter distance etc...
    fetchInput(): void {
        this.nRoofHeight = RoofShape.getCurrentRoofHeight();
        this.nRoofWidth = RoofShape.getCurrentRoofWidth();
        if (!SC_Input.updatedBeamInput) {
            if (SC_Input.iBeamType == SC_Beam.PURLIN) {
                this.nRoofRange = this.nRoofHeight;
            } else {
                this.nRoofRange = this.nRoofWidth;
            }
            this.nDistMin = SC_Input.beamMinMax.nDistMin;
            this.nDistMax = SC_Input.beamMinMax.nDistMax;
            this.nDistDefault = SC_Input.beamMinMax.nDistDefault;
            SC_Input.nRoofRange = this.nRoofRange;
            this.initValues();
            if (SC_Input.nBeamDist < this.nDistMin || SC_Input.nBeamDist > this.nDistMax) {
                SC_Input.nBeamDist = this.nDistDefault;
                SC_Input.nBeamDist1 = 10;
                SC_Input.nBeamDist2 = (this.nRoofRange - SC_Input.nBeamDist1) % SC_Input.nBeamDist;
                SC_Input.iBeamAmount = Math.floor((this.nRoofRange - (SC_Input.nBeamDist1 + SC_Input.nBeamDist2)) / SC_Input.nBeamDist) + 1;
            }
        }
        SC_Beam.drawBeam(this.layerBeam);
        this.layerBeam.draw();
    }
    // based upon initial values calculating other fileds values and updating 
    initValues() {
        this.nsDist2_value = (this.nRoofRange - this.nsDist1_value) % this.nsDist_value;
        this.nsAmount_value = Math.floor((this.nRoofRange - this.nsDist1_value) / this.nsDist_value) + 1;
        SC_Input.nBeamDist = this.nDistDefault;
        SC_Input.nBeamDist1 = 10;
        SC_Input.nBeamDist2 = this.nsDist2_value;
        SC_Input.iBeamAmount = Math.floor((this.nRoofRange - (SC_Input.nBeamDist1 + SC_Input.nBeamDist2)) / SC_Input.nBeamDist) + 1;
    }


}